import 'bootstrap/dist/css/bootstrap.min.css';

import GAListener from './context/GAListener';


import React, { useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { toast } from 'react-toastify';
import { css } from 'glamor';


import 'react-toastify/dist/ReactToastify.css';
import './styles/reduction.scss';
import 'filepond/dist/filepond.min.css';



import RouteTable from './shared/components/custom-routes/RouteTable';
import { NavigationProvider } from './context/NavigationContext';
import { useAuth } from './context/AuthContext';
import { AccountProvider } from './context/AccountContext';

const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split('/').pop()}`;
};


toast.configure({
  ClassName: css({
    background: 'green',
  }),
});



function App() {
 const { isAuthenticated } = useAuth()
  //
  // const generateRoutesFromCategories = (categories, basePath = '\/') => {
  //   return categories.map((category) => {
  //     const fullpath = `${basePath}/${category.path}`.replace(/\/+/g, '/');
  //     if (category.children) {
  //       return generateRoutesFromCategories(category.children, fullpath); // Recursively generate routes for any children
  //     } else if (category.component) {
  //       return (
  //         <AppRoute
  //           key={fullpath} // Ensure keys are unique
  //           exact
  //           path={fullpath}
  //           layout={(props) => (
  //             <AppLayout {...props} />
  //           )}
  //           component={(props) => <category.component {...props} />}
  //
  //         />
  //       );
  //     }
  //     return null; // For categories without components
  //   });
  // };

  return (

      <NavigationProvider isAuthenticated={isAuthenticated}>
       <AccountProvider  isAuthenticated={isAuthenticated} >
          <BrowserRouter basename={'/'}>
            <GAListener>
              <RouteTable />
            </GAListener>
          </BrowserRouter>
        </AccountProvider>
      </NavigationProvider>

  );
//change navigation provider to menu provider
  // change state provider to plan and feature provider and move higher up the rank try to remove the reducer
}

export default App;
